import React, {FunctionComponent, useState} from 'react';
import {Manager, Popper, Reference} from 'react-popper';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import styled from 'styled-components';
import PingUser from '~/lib/auth/ping/PingUser';
import ProfileIcon from '../../icons/Profile.svg';

const UserIconContainer = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 48px;
    padding-right: 2px;
`;

const UserIcon = styled.div`
    align-items: center;
    background-color: #a9e079;
    border-radius: 99px;
    display: flex;
    flex: none;
    flex-direction: row;
    flex-grow: 0;
    gap: 10px;
    justify-content: center;
    height: 32px;
    order: 2;
    width: 32px;
`;

interface Props {
    user: PingUser;
    onLogout: () => void;
}

const UserMenu: FunctionComponent<Props> = ({user, onLogout}) => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <Manager>
            <Reference>
                {({ref}) => (
                    <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
                        <UserIconContainer ref={ref} onClick={() => setMenuOpen(!menuOpen)}>
                            <UserIcon>
                                <img className="user-menu-icon" src={ProfileIcon} />
                            </UserIcon>
                        </UserIconContainer>
                    </ClickAwayListener>
                )}
            </Reference>
            {menuOpen && (
                <Popper placement="bottom-end">
                    {({placement, ref, style}) => (
                        <div
                            ref={ref}
                            data-placement={placement}
                            className="user-menu"
                            style={style}
                        >
                            <Button className="logout" disableElevation onClick={onLogout}>
                                Sign Out
                            </Button>
                        </div>
                    )}
                </Popper>
            )}
        </Manager>
    );
};

export default UserMenu;
